<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Users</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row class="subtitle-2 text--primary mt-2">
          <v-btn color="primary" small to="/new-user">
            <v-icon left dark>mdi-plus</v-icon>New User
          </v-btn>
        </v-row>

        <v-row>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="12">
            <!-- start of table -->
            <v-data-table
              :items-per-page="pageItems"
              :headers="headers"
              :items="users"
              :search="search"
            >

                <!-- target template -->
                <template v-slot:item.monthlySalesTarget="{ item }">
                <span>{{ item.monthlySalesTarget | currency }}</span>
              </template>
              <!-- end -->

               <!-- action template -->
               <template v-slot:item.login="{ item }">
                <v-btn color="primary" text :to="`/edit-user/password/${item.id}`">
                  <v-icon left>mdi-pen-lock</v-icon> Change Password
                </v-btn>
              </template>
              <!-- end -->

              <!-- user pin template -->
               <template v-slot:item.userPin="{ item }">
                <span v-show="item.role != 3">{{ item.userPin }}</span>
              </template>
              <!-- end -->

              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn color="accent" text :to="`/edit-user/${item.id}`">
                  <v-icon left>mdi-pencil</v-icon> Edit
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>

        <v-row>
          <!-- roles assignment -->
          <v-dialog v-model="rolesDialog" max-width="750px">
            <v-card>
              <v-toolbar dense color="primary" dark>
                <v-toolbar-title>Assign A Group To A User</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="rolesDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-container fluid class="subtitle-2 text--primary">
                  <v-row class="subtitle-2 text--primary">
                    <v-col cols="12" xs="12" md="6">
                      <v-text-field
                        filled
                        readonly
                        v-model="record.name"
                        outlined
                        dense
                        label="User"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" xs="12" md="6">
                      <v-autocomplete
                        autocomplete="off"
                        dense
                        outlined
                        v-model="record.RoleId"
                        :items="userGroups"
                        label="User Group"
                        item-text="name"
                        item-value="id"
                      ></v-autocomplete>
                    </v-col>

                    <v-col cols="12" xs="12" sm="12" md="6">
                      <v-btn color="accent" @click="save" :loading="loader"
                        >Assign Group</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end -->

          <!-- roles assignment -->
          <v-dialog v-model="assignedDialog" max-width="600px">
            <v-card>
              <v-toolbar dense color="primary" dark>
                <v-toolbar-title>Groups Assigned</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="assignedDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-container fluid class="subtitle-2 text--primary">
                  <v-row class="subtitle-2 text--primary">
                    <v-col cols="12" xs="12" md="12">
                      <span v-if="roleItem">{{ roleItem.name }}</span>
                    </v-col>

                    <v-col
                      cols="12"
                      xs="12"
                      md="12"
                      v-if="roleItem.roles && roleItem.roles.length > 0"
                    >
                      <v-data-table
                        dense
                        :items-per-page="20"
                        :headers="roleHeaders"
                        :items="roleItem.roles"
                      >
                        <!-- action template -->
                        <template v-slot:item.action="{ item }">
                          <v-btn text color="red" @click="denyModal(item)">
                            Deny Rights
                            <v-icon right>mdi-close</v-icon>
                          </v-btn>
                        </template>
                        <!-- end -->
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end -->

          <!-- roles assignment -->
          <v-dialog v-model="denyDialog" max-width="600px">
            <v-card>
              <v-toolbar dense color="red" dark>
                <v-toolbar-title>Deny Group Rights</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="denyDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-container fluid class="subtitle-2 text--primary">
                  <v-row class="subtitle-2 text--primary">
                    <v-col cols="12" xs="12" md="12">
                      Are you sure you want to deny the following group
                      rights?<br /><br />
                      <span v-if="roleItem" style="color: red">{{
                        denyItem.name
                      }}</span>
                    </v-col>

                    <v-col cols="12" xs="12" md="12">
                      <v-btn
                        color="red"
                        @click="denyRights"
                        :loading="loader"
                        dark
                        >Yes</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end -->
        </v-row>

        <snackbar ref="snackbar"></snackbar>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import snackbar from "../../../global/snackbar.vue";
export default {
  components: { snackbar },
  data: () => ({
    search: "",
    pageItems: 100,
    rolesDialog: false,
    assignedDialog: false,
    denyDialog: false,
    denyItem: {},
    roleItem: {},
    loader: false,
    record: {},
    headers: [
      { text: "Name", value: "name" },
      { text: "Email", value: "email" },
      { text: "Phone", value: "phoneNumber" },
      { text: "Shop", value: "shopName" },
      { text: "User Name", value: "userName" },
      { text: "User Pin", value: "userPin" },
      // { text: "Monthly Sales Target", value: "monthlySalesTarget" },
      { text: "Edit", value: "action" },
      { text: "Password Change", value: "login" }
    ],
    roleHeaders: [
      { text: "Name", value: "name" },
      { text: "Edit", value: "action" },
    ],
    users: [],
    userGroups: [],
  }),
  methods: {
    denyModal(data) {
      this.denyItem = data;
      this.denyDialog = true;
    },
    groupModal(data) {
      this.record = data;
      this.rolesDialog = true;
    },
    rolesModal(data) {
      this.roleItem = data;
      this.assignedDialog = true;
    },
    save() {
      if (this.record.RoleId == null || this.record.RoleId == undefined) {
        this.$refs.snackbar.show("Please select group", "red");
      } else {
        const data = {
          role_id: this.record.RoleId,
        };
        const url = `/user/assign-role/${this.record.id}`;
        const self = this;
        this.loader = true;
        this.$store
          .dispatch("post", { url, data })
          .then((res) => {
            if (res.ResultCode == 1200) {
              self.getUsers();
              self.loader = false;
              self.rolesDialog = false;
            } else {
              this.$refs.snackbar.show(res.ResultDesc, "red");
            }
          })
          .catch((err) => {
            this.$refs.snackbar.show(err, "red");
          });
      }
    },
    denyRights() {
      const data = {
        role_id: this.denyItem.id,
      };
      const url = `/user/deny-role/${this.roleItem.id}`;
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.getUsers();
            self.loader = false;
            self.denyDialog = false;
            self.assignedDialog = false;
            self.rolesDialog = false;
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getUsers() {
      const self = this;
      this.$store
        .dispatch("get", `/users`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.users = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    this.getUsers();
  },
};
</script>